import { render, staticRenderFns } from "./VideoCallRoomMinimum.vue?vue&type=template&id=64c8f6e6&scoped=true&"
import script from "./VideoCallRoomMinimum.vue?vue&type=script&lang=ts&"
export * from "./VideoCallRoomMinimum.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallRoomMinimum.vue?vue&type=style&index=0&id=64c8f6e6&lang=scss&scoped=true&"
import style1 from "./VideoCallRoomMinimum.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8f6e6",
  null
  
)

export default component.exports